import {
  GET_USUARIOS_RECOLECCION_START,
  GET_USUARIOS_RECOLECCION_SUCCESS,
  GET_USUARIOS_RECOLECCION_ERROR
} from '../actions'

const initialState = {
  loading: false,
  payload: [],
  error: null
}

const usuarios = (state = initialState, { type, payload, error }) => {

  switch(type) {

    case GET_USUARIOS_RECOLECCION_START:
      return {
        ...state,
        loading: true,
        error: null
      }

    case GET_USUARIOS_RECOLECCION_SUCCESS:
      return {
        ...state,
        loading: false,
        payload
      }

    case GET_USUARIOS_RECOLECCION_ERROR:
      return {
        ...state,
        loading: false,
        error
      }

    default: return state

  }

}

export default usuarios